module.exports = __webpack_public_path__ + "static/media/spinner.e9d9dd6d.svg";